import { toast } from "react-toastify";
import { RepositoryFactory } from "repository/RepositoryFactory";

const orders = RepositoryFactory.get("orders");

export const getAllOrdersAction = (status, page) => async (dispatch) => {
  try {
    dispatch({
      type: "GET_ORDERS_LOADER",
      payload: true,
    });
    const { data } = await orders.getOrders(status, page);

    dispatch({
      type: "GET_ORDERS",
      payload: data.data,
    });
    dispatch({
      type: "GET_ORDERS_LOADER",
      payload: false,
    });
  } catch (err) {
    toast.error(err.response?.data?.message || err.message || "Failed to load orders");
    dispatch({
      type: "GET_ORDERS_LOADER",
      payload: false,
    });
  }
};
export const getSpecialOrders = (status, page) => async (dispatch) => {
  try {
    dispatch({
      type: "GET_ORDERS_LOADER",
      payload: true,
    });
    const { data } = await orders.getSpecialOrders(status, page);

    dispatch({
      type: "GET_SPECIAL_ORDERS",
      payload: data.data,
    });
    dispatch({
      type: "GET_ORDERS_LOADER",
      payload: false,
    });
  } catch (err) {
    toast.error(err.response?.data?.message || err.message || "Failed to load special orders");
    dispatch({
      type: "GET_ORDERS_LOADER",
      payload: false,
    });
  }
};

export const orderSearchByIdAction = (id, page) => async (dispatch) => {
  try {
    dispatch({
      type: "GET_ORDERS_LOADER",
      payload: true,
    });
    const { data } = await orders.orderSearchById(id, page);

    if (data?.success) {
      dispatch({
        type: "GET_ORDER_SEARCH_BY_ID",
        payload: data,
      });

      dispatch({
        type: "GET_ORDERS_LOADER",
        payload: false,
      });
    }
  } catch (error) {
    toast.error(error.response?.data?.message || error.message || "Search failed");
    dispatch({
      type: "GET_ORDERS_LOADER",
      payload: false,
    });
  }
};
export const specialOrderSearchById = (id, page) => async (dispatch) => {
  try {
    dispatch({
      type: "GET_ORDERS_LOADER",
      payload: true,
    });
    const { data } = await orders.specialOrderSearchById(id, page);

    if (data?.success) {
      dispatch({
        type: "GET_SPECIAL_ORDER_SEARCH_BY_ID",
        payload: data,
      });

      dispatch({
        type: "GET_ORDERS_LOADER",
        payload: false,
      });
    }
  } catch (error) {
    toast.error(error.response?.data?.message || error.message || "Search failed");
    dispatch({
      type: "GET_ORDERS_LOADER",
      payload: false,
    });
  }
};
export const releasePayment =
  (id, status, page, onSuccess) => async (dispatch) => {
    try {
      dispatch({
        type: "GET_ORDERS_LOADER",
        payload: true,
      });
      const { data } = await orders.releasePayment(id);

      if (data?.success) {
        await dispatch(getSpecialOrders(status, page));
        toast.success(data?.message);
        onSuccess();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || error.message || "Failed to release payment");
      dispatch({
        type: "GET_ORDERS_LOADER",
        payload: false,
      });
    }
  };
